<template>
  <div class="video-playground bg-gray-50 dark:bg-gray-900 p-6">
    <div class="max-w-2xl mx-auto text-center py-16">
      <Card padding="lg">
        <svg
          class="w-16 h-16 mx-auto text-gray-400 dark:text-gray-500 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
        <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Video Generation
        </h3>
        <p class="text-gray-600 dark:text-gray-400 mb-4">
          Video generation capabilities are coming soon.
        </p>
        <Badge variant="warning" size="lg">Coming Soon</Badge>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Badge, Card } from '@asabdev/asab-ui';
</script>
